import moment from "moment";
import { RENTACAR_CONSTANTS } from "../rentacarConstants";

const timetable = RENTACAR_CONSTANTS.TIMETABLE;
const format = "YYYY-MM-DD HH:mm";

export const disabledDates = (current, carFilterParams) => {
  const refTime = moment(current);
  const summerPeriod = {
    start: {
      month: 4, // May 1st
      day: 1,
    },
    end: {
      month: 9, // October 1st
      day: 1,
    },
  };
  let season = "";

  // set the season for current date
  if (
    (current.month() === summerPeriod.start.month &&
      parseInt(current.format("D")) >= summerPeriod.start.day) ||
    (current.month() > summerPeriod.start.month &&
      current.month() < summerPeriod.end.month) ||
    (current.month() === summerPeriod.end.month &&
      parseInt(current.format("D")) <= summerPeriod.end.day)
  ) {
    season = "summer";
  } else {
    season = "winter";
  }

  const isTooSoon = current.isBetween(
    moment(refTime.set("hour", 0).set("minute", 0), format),
    moment(
      refTime
        .set("hour", timetable[season].morning.open.hour)
        .set("minute", timetable[season].morning.open.minute),
      format
    ),
    null,
    "()"
  );
  const isLunchTime = current.isBetween(
    moment(
      refTime
        .set("hour", timetable[season].morning.close.hour)
        .set("minute", timetable[season].morning.close.minute),
      format
    ),
    moment(
      refTime
        .set("hour", timetable[season].afternoon.open.hour)
        .set("minute", timetable[season].afternoon.open.minute),
      format
    ),
    null,
    "[)"
  );
  const isTooLate = current.isBetween(
    moment(
      refTime
        .set("hour", timetable[season].afternoon.close.hour)
        .set("minute", timetable[season].afternoon.close.minute),
      format
    ),
    moment(refTime.set("hour", 23).set("minute", 59), format),
    null,
    "[]"
  );
  let result = isTooSoon || isLunchTime || isTooLate;
  return result;
};
